import styled, { css } from 'styled-components'
import { colors, fonts, FC_SPRING_EASE } from 'shared/lib'

export const FieldRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const FieldContainer = styled.div<{ $focused: boolean; $hasValue: boolean; $hasError: boolean }>`
  position: relative;
  height: 56px;
  border: 1px solid ${colors.FC2_LIGHTEST_GREY};
  border-radius: 4px;
  background: ${colors.FC2_WHITE};
  transition: border-color 150ms ${FC_SPRING_EASE};

  ${({ $focused, $hasValue, $hasError }) =>
    $hasError
      ? css`border-color: ${colors.FC2_RED};`
      : ($focused || $hasValue)
        ? css`border-color: ${colors.FC2_BLACK};`
        : ''}
`

export const FieldLabel = styled.label<{ $floated: boolean; $hasError: boolean }>`
  position: absolute;
  top: 10px;
  left: 16px;
  ${fonts.SUBTITLE_3}
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: ${({ $hasError }) => ($hasError ? colors.FC2_RED : colors.FC2_GREY)};
  pointer-events: none;
  transform-origin: left center;
  transition: transform 150ms ${FC_SPRING_EASE}, color 150ms ${FC_SPRING_EASE};
  transform: ${({ $floated }) =>
    $floated ? 'translateY(0) scale(1)' : 'translateY(10.8px) scale(1.1667)'};
`

export const FieldInput = styled.input<{ $showClear: boolean }>`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  padding: 28px 16px 8px 16px;
  ${fonts.SUBTITLE_2}
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: ${colors.FC2_BLACK};
  text-transform: none;
  ${({ $showClear }) => ($showClear ? 'padding-right: 44px;' : '')}

  &:disabled {
    color: ${colors.FC2_GREY};
    cursor: not-allowed;
  }
`

export const ClearButton = styled.button`
  position: absolute;
  right: 6px;
  top: 6px;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${colors.FC2_LIGHTEST_GREY};
  }

  &::after {
    content: '✕';
    position: absolute;
    font-size: 10px;
    color: ${colors.FC2_BLACK};
    line-height: 1;
  }
`

export const ErrorText = styled.div`
  ${fonts.SUBTITLE_3}
  font-size: 12px;
  color: ${colors.FC2_RED};
  margin-top: 4px;
  margin-left: 2px;
`
